import { useCallback, useEffect, useRef, useState } from 'react'

import styles from './CoinLockerMapSection.module.scss'
import CoinLockerMapComponent from 'components/maps/CoinLockerMapComponent'
import { useGoogleMapLogger } from 'hooks/logger/useGoogleMapLogger'

interface Props {
  centerLat: number
  centerLon: number
  coinLockers: any[]
  oldCoinLockers?: any[]
  scrollToRecommendedCoinLockerSection(id: number, isOld?: boolean): void
}

const CoinLockerMapSection: React.FC<Props> = ({
  centerLat,
  centerLon,
  coinLockers,
  oldCoinLockers = [],
  scrollToRecommendedCoinLockerSection,
}: Props) => {
  const mapRef = useRef(null)

  const { logGoogleMapUsage } = useGoogleMapLogger()
  // const zoom = 16

  const initGoogleMap = (map) => {
    mapRef.current = map
    logGoogleMapUsage({
      timestamp: new Date().toISOString(),
      screen: window.location.pathname,
      env: process.env.SENTRY_ENVIRONMENT || 'staging',
      platform: 'web',
      action_type: 'load_map',
      api_sku: 'Dynamic Maps',
      latitude: centerLat,
      longitude: centerLon,
      user_input_text: '',
    })
  }

  return (
    <div className={styles.section}>
      <CoinLockerMapComponent
        lat={centerLat}
        lon={centerLon}
        zoomLabel={16}
        coinLockers={coinLockers}
        oldCoinLockers={oldCoinLockers}
        mapRef={mapRef}
        initGoogleMap={initGoogleMap}
        scrollToRecommendedCoinLockerSection={scrollToRecommendedCoinLockerSection}
      />
    </div>
  )
}

export default CoinLockerMapSection
